import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Props } from 'shared/@types';
import { useRouter } from 'shared/library/use-router';
import { env } from 'shared/library/env';
import { monitoring } from 'shared/library/monitoring';
import dynamic from 'next/dynamic';

const AppErrorFallback = dynamic(
  () => import('@web/components/app-error-fallback').then((mod) => mod.AppErrorFallback),
  { ssr: false },
);

export function AppErrorBoundary({ children }: Props) {
  const router = useRouter();

  const onError = (error: Error, info: { componentStack?: string | null }) => {
    monitoring.Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: info.componentStack || undefined,
        },
      },
    });
  };

  const fallbackRender = ({ error }: FallbackProps) => {
    if (env.IS_DEV && !env.E2E)
      return (
        <div style={{ padding: 40 }}>
          <h2>Error occurred</h2>
          <pre>{error.message}</pre>
          <pre>{error.stack}</pre>
        </div>
      );

    return <AppErrorFallback error={error} />;
  };

  return (
    <ErrorBoundary key={router.pathname} fallbackRender={fallbackRender} onError={onError}>
      {children}
    </ErrorBoundary>
  );
}
